import {
  NomChartType,
  chartTypeIdToVisualizationTypeMap,
} from '../models/widget.models';

import { FormProperty } from '../models/form.models';
import { Injectable } from '@angular/core';
import { PopupTabConfig } from 'src/app/admin/models';
import { VisualizationType } from '../models/widget.models';
import { WidgetType } from '../constants';

export const ALL_TYPES = 'all';

@Injectable({
  providedIn: 'root',
})
export class WidgetSettingsService {
  propertyMap = {
    language_picker: {
      [ALL_TYPES]: true,
    },
    title: {
      [ALL_TYPES]: true,
    },
    widget_annotation: {
      [ALL_TYPES]: true,
    },
    tabs: {
      [ALL_TYPES]: true,
    },
    widget_general: {
      [ALL_TYPES]: true,
    },
    export_and_share: {
      [ALL_TYPES]: true,
    },
    object_audit_trail: {
      [ALL_TYPES]: true,
    },
    chart_data_series: {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
      },
    },
    chart_layout: {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
      },
    },
    chart_axes: {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
      },
    },
    content_view_properties: {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
      },
    },
    debug_chart_config: {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
      },
    },
    debug_chart_json: {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
      },
    },
    'settings.widget_portrait_max_width': {
      [ALL_TYPES]: true,
    },
    'settings.widget_portrait_max_height': {
      [ALL_TYPES]: true,
    },
    'settings.widget_landscape_max_width': {
      [ALL_TYPES]: true,
    },
    'settings.widget_landscape_max_height': {
      [ALL_TYPES]: true,
    },
    'settings.page_break_before_each_post': {
      [ALL_TYPES]: true,
    },
    'settings.use_synopsis_title_if_available': {
      [ALL_TYPES]: true,
    },
    'settings.use_synopsis_content_if_available': {
      [ALL_TYPES]: true,
    },
    'settings.export': {
      [WidgetType.WIDGET_TYPE_POST_LIST]: true,
    },
    'settings.feed.view_properties': {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
      },
    },
    'settings.activate_others': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
        Summary: false,
        Html: false,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.export_formats': {
      [ALL_TYPES]: true,
    },

    // ! Summary Widget type uses `settings.metrics`
    'settings.metrics': {
      vizTypes: {
        Summary: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
      },
    },

    'settings.summary_enable_trends': {
      vizTypes: {
        Summary: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
      },
    },

    // ! Html Widget type uses `settings.filters`
    'settings.filters': {
      vizTypes: {
        Html: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_HTML]: true,
      },
    },

    'settings.feed.media_channel_id': {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
      },
    },

    'settings.chart_background_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart_border_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart_border_line_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: true,
      },
    },
    'settings.chart_stacking': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart.margin_bottom': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart.margin_left': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart.margin_right': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart.margin_top': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart.spacing_bottom': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart.spacing_left': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart.spacing_right': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.chart.spacing_top': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.period_gap': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: false,
        Cloud: false,
        Column: false,
        GeoMap: false,
        Heatmap: false,
        Line: true,
        SentimentAverage: true,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.background_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.distance': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.font_size': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.format': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.inside': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.padding_left': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.padding_right': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.rotation': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: true,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: true,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: true,
      },
    },
    'settings.data_labels.x_offset': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: true,
      },
    },
    'settings.data_labels.y_offset': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.datasource_filter_by_first': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.datasource_object_id': {
      [ALL_TYPES]: true,
    },
    'settings.dimension_id_filter': {
      [ALL_TYPES]: true,
    },
    'settings.dimension_id_pivot': {
      // TODO: keep the commented part for now - do not delete it!
      // vizTypes: {
      //   AreaSpline: true,
      //   Area: true,
      //   Bar: true,
      //   Column: true,
      //   Heatmap: true,
      //   Line: true,
      //   SentimentAverage: true,
      //   Spline: true,
      // },
      // widgetTypes: {
      //   [WidgetType.WIDGET_TYPE_CHART]: true,
      // },
      // ! apply to all types - we need some visual feedback for the user
      // ! so, we need to display the component
      [ALL_TYPES]: true,
    },
    'settings.fill_opacity': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.icon_uri': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: true,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: true,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: true,
      },
    },
    'settings.section_break_page_break_before': {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
        [WidgetType.WIDGET_TYPE_HTML]: true,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: true,
      },
    },
    'settings.widget_header_color': {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
        [WidgetType.WIDGET_TYPE_HTML]: true,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: true,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: true,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: true,
      },
    },
    'settings.post_background_color': {
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
      },
    },
    'settings.legend.background_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.legend.font_size': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.legend.h_align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.legend.item_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.legend.labels_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.legend.layout': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.legend.symbol_size': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.legend.v_align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.number_of_items': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
        Table: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
        [WidgetType.WIDGET_TYPE_HTML]: true,
      },
    },
    'settings.data_point_sort': {
      vizTypes: {
        AreaSpline: false,
        Area: false,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: false,
        SentimentAverage: false,
        Pie: true,
        Spline: false,
        Table: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.dataset_colors_source': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
        Table: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.custom_period': {
      vizTypes: {},
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
      },
    },
    'settings.feed.content_filters.time_start': {
      vizTypes: {},
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
      },
    },
    'settings.feed.content_filters.time_end': {
      vizTypes: {},
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
      },
    },
    'settings.feed.content_filters.order': {
      // Clipping: Top Online content
      vizTypes: {},
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
      },
    },
    'settings.feed.content_filters.sort': {
      // Clipping: Top Online content
      vizTypes: {},
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
      },
    },
    'settings.order_by_field.filter': {
      // Top Influencers
      vizTypes: {},
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_HTML]: true,
      },
    },
    'settings.display_unique_sources': {
      vizTypes: {},
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
      },
    },
    'settings.display_unique_titles': {
      vizTypes: {},
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_POST_LIST]: true,
      },
      chartTypeIds: {
        [NomChartType.TopOnlineContent]: true,
        [NomChartType.TopTwitterContent]: false,
        [NomChartType.TopFacebookContent]: false,
      },
    },
    'settings.plot_background_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: true,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: true,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: true,
      },
    },
    'settings.plot_border_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.plot_border_line_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.series.border_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: true,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.series.border_radius': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.series.border_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.series.color_source': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.series.line_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_chart_legend': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_chart_title': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: true,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_data_labels': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_series_markers': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_stack_labels': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_x_axis_grid_lines': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_x_axis_labels': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_x_axis_line': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_x_axis_ticks': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_x_axis_title': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_y_axis_grid_lines': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_y_axis_labels': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_y_axis_line': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_y_axis_ticks': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.show_y_axis_title': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.background_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.font_size': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.format': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.inside': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.padding_left': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.padding_right': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.rotation': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.x_offset': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.stack_labels.y_offset': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.title.color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.title.font_size': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.title.h_align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.title.margin_bottom': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.title.padding_bottom': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.title.padding_left': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.title.padding_right': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.title.padding_top': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.title.v_align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: true,
        Column: true,
        GeoMap: true,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.grid_line_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.grid_line_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.labels.align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.labels.color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.labels.font_size': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.labels.rotation': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.labels.wrap': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.line_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.line_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.max_padding': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.ticks.tick_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.ticks.tick_length': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.ticks.tick_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.title.align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.title.color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.title.font_size': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.x_axis.title.rotation': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.grid_line_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.grid_line_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.labels.align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.labels.color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.labels.font_size': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.labels.rotation': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.labels.wrap': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.line_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.line_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.max_padding': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.ticks.tick_color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.ticks.tick_length': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.ticks.tick_width': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.title.align': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.title.color': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.y_axis.title.font_size': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: true,
      },
    },
    'settings.y_axis.title.rotation': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: false,
        Pie: false,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: true,
      },
    },
    'settings.pie_semi_circle_size': {
      vizTypes: {
        AreaSpline: false,
        Area: false,
        Bar: false,
        Cloud: false,
        Column: false,
        GeoMap: false,
        Heatmap: false,
        Line: false,
        SentimentAverage: false,
        Pie: true,
        Spline: false,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.pie_rotation': {
      vizTypes: {
        AreaSpline: false,
        Area: false,
        Bar: false,
        Cloud: false,
        Column: false,
        GeoMap: false,
        Heatmap: false,
        Line: false,
        SentimentAverage: false,
        Pie: true,
        Spline: false,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.pie_total_radius': {
      vizTypes: {
        AreaSpline: false,
        Area: false,
        Bar: false,
        Cloud: false,
        Column: false,
        GeoMap: false,
        Heatmap: false,
        Line: false,
        SentimentAverage: false,
        Pie: true,
        Spline: false,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.pie_view_type': {
      vizTypes: {
        AreaSpline: false,
        Area: false,
        Bar: false,
        Cloud: false,
        Column: false,
        GeoMap: false,
        Heatmap: false,
        Line: false,
        SentimentAverage: false,
        Pie: true,
        Spline: false,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.slice_color_id': {
      vizTypes: {
        AreaSpline: false,
        Area: false,
        Bar: false,
        Cloud: false,
        Column: false,
        GeoMap: false,
        Heatmap: false,
        Line: false,
        SentimentAverage: false,
        Pie: true,
        Spline: false,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.data_labels.percent_field': {
      vizTypes: {
        AreaSpline: true,
        Area: true,
        Bar: true,
        Cloud: false,
        Column: true,
        GeoMap: false,
        Heatmap: true,
        Line: true,
        SentimentAverage: true,
        Pie: true,
        Spline: true,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: false,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },

    // gradients for heatmap
    'settings.gradient_color_min': {
      vizTypes: {
        AreaSpline: false,
        Area: false,
        Bar: false,
        Cloud: false,
        Column: false,
        GeoMap: true,
        Heatmap: true,
        Line: false,
        SentimentAverage: false,
        Pie: false,
        Spline: false,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
    'settings.gradient_color_max': {
      vizTypes: {
        AreaSpline: false,
        Area: false,
        Bar: false,
        Cloud: false,
        Column: false,
        GeoMap: true,
        Heatmap: true,
        Line: false,
        SentimentAverage: false,
        Pie: false,
        Spline: false,
      },
      widgetTypes: {
        [WidgetType.WIDGET_TYPE_CHART]: true,
        [WidgetType.WIDGET_TYPE_TABLE]: false,
        [WidgetType.WIDGET_TYPE_POST_LIST]: false,
        [WidgetType.WIDGET_TYPE_GEO_MAP]: true,
        [WidgetType.WIDGET_TYPE_SUMMARY]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_USER]: false,
        [WidgetType.WIDGET_TYPE_EXPORT_VARIABLES_SYSTEM]: false,
        [WidgetType.WIDGET_TYPE_SECTION_BREAK]: false,
      },
    },
  };
  constructor() {}

  public hasProperty(
    propertyName: string,
    widgetTypeId: WidgetType,
    vizType?: VisualizationType, // make it optional
    chartTypeId?: number,
  ): boolean {
    // console.log('');
    // console.log('hasProperty(s0) -> propertyName:', propertyName, '| widgetTypeId:', widgetTypeId, '| vizType:', vizType, '| chartTypeId: ', chartTypeId);
    const prop = this.propertyMap[propertyName];
    if (!prop) {
      return false;
    }

    // Always allow "ALL_TYPES"
    if (prop[ALL_TYPES]) {
      return true;
    }

    // Specificity 1: if set & false or not set, return false; if set to true, continue with true (required explicit filter)
    const widgetTypeVisibility = prop['widgetTypes']?.[widgetTypeId] ?? false;
    // console.log('hasProperty(s1) -> propertyName:', propertyName, '| widgetTypeVisibility:', widgetTypeVisibility);
    if (!widgetTypeVisibility) {
      return false;
    }

    // Specificity 2: if set to false, return false; if not set or true, continue with true
    const chartTypeIdVisibility = prop['chartTypeIds']?.[chartTypeId] ?? true;
    // console.log('hasProperty(s2) -> propertyName:', propertyName, '| chartTypeVsibility:', chartTypeIdVisibility, '| widgetTypeVisibility:', widgetTypeVisibility);
    if (!chartTypeIdVisibility) {
      return false;
    }

    // Specificity 3: if set to false, continue with false; if not set or true, continue with true
    const vizTypeVisibility = prop['vizTypes']?.[vizType] ?? true;
    // console.log('hasProperty(s3) -> propertyName:', propertyName, '| vizTypeVisibility:', vizTypeVisibility, '| chartTypeVsibility:', chartTypeIdVisibility, '| widgetTypeVisibility:', widgetTypeVisibility);
    // Otherwise, check vizType && chartIdVisibility
    return vizTypeVisibility && chartTypeIdVisibility && widgetTypeVisibility;
  }

  public filterFormProperties(
    formProperties: FormProperty[],
    widgetTypeId: WidgetType,
    vizType: VisualizationType,
    chartTypeId?: number,
  ): FormProperty[] {
    return formProperties.filter((formProperty: FormProperty) => {
      if (formProperty.propertyNames) {
        return formProperty.propertyNames.every((name) =>
          this.hasProperty(name, widgetTypeId, vizType, chartTypeId),
        );
      }
      return this.hasProperty(
        formProperty.propertyName,
        widgetTypeId,
        vizType,
        chartTypeId,
      );
    });
  }

  public getMassUpdateFormProperties(
    formProperties: FormProperty[],
    widgetTypeIds: WidgetType[],
    chartTypeIds: number[] = [],
  ): FormProperty[] {
    return formProperties.filter((fp) => {
      if (!fp.isMassUpdate) return false;

      const propertyNames = fp.propertyNames || [fp.propertyName];

      return widgetTypeIds.every((widgetTypeId) => {
        return propertyNames.every((propertyName) => {
          // If no chart types are specified, check only widget type visibility.
          if (chartTypeIds.length === 0) {
            return this.hasProperty(propertyName, widgetTypeId);
          }

          const propertyVizTypeIds = Object.keys(
            this.propertyMap[propertyName]?.vizTypes || {},
          ).map((id) => Number(id));

          // If the property is not defined for any chart types, check only widget type visibility.
          if (propertyVizTypeIds.length === 0) {
            return this.hasProperty(propertyName, widgetTypeId);
          }

          // Otherwise, must be visible for specific chart types too.
          return chartTypeIds.every((chartTypeId) => {
            const vizTypeId =
              chartTypeIdToVisualizationTypeMap.get(chartTypeId);

            return this.hasProperty(
              propertyName,
              widgetTypeId,
              vizTypeId,
              chartTypeId,
            );
          });
        });
      });
    });
  }

  public filterTabs(
    tabs: PopupTabConfig[],
    widgetTypeId: WidgetType,
    vizType: VisualizationType,
  ): PopupTabConfig[] {
    return tabs.filter((tab: PopupTabConfig) => {
      if (this.hasProperty(tab.key, widgetTypeId, vizType) === false) {
        return !tab.key;
      }
      return true;
    });
  }
}
